import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_ISSUE_INVENTORY,
   ADD_MANY_ISSUE_INVENTORY,
   UPDATE_ISSUE_INVENTORY,
   GET_ISSUE_INVENTORY,
   GET_ISSUES_INVENTORY,
   DELETE_ISSUE_INVENTORY,
   EMPTY_ONE_ISSUE_INVENTORY,
   GET_LAST_ISSUE_DAYBOOK,
   GET_ISSUE_INVENTORY_PREV_AND_NEXT,
   GET_SINGLE_ISSUES_INVENTORY,
   UPDATE_ISSUE_DOC,
   DELETE_ISSUE_DOC,
   DELETE_MULTI_ISSUE,
} from '../types';

export const deleteMultiIssue = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/issue-inventory/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_ISSUE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Sales Invoice deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const addIssueInventory = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue-inventory/add`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_ISSUE_INVENTORY,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Issue Inventory added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/issue-inventory/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

export const addManyIssueInventory = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue-inventory/addMany`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_MANY_ISSUE_INVENTORY,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Issue added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const getIssueInventories = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/issue-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ISSUES_INVENTORY,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      console.error('getIssueInventories err', err);
   }
};

export const getSingleIssueInventories = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/issue-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SINGLE_ISSUES_INVENTORY,
            payload: {
               data: res.data || [],
               // pagination: res.data.pagination || {},
               // totalCount: res.data.totalCount || 0,
            },
         });
      }
      console.log('res', res);
   } catch (err) {
      console.error('getIssueInventories err', err);
   }
};

export const getIssueInventory = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/issue-inventory/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_ISSUE_INVENTORY,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('getIssueInventory err', err);
   }
};

export const deleteIssueInventory = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue-inventory/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: DELETE_ISSUE_INVENTORY,
            payload: { id },
         });
         setTimeout(() => {
            toast.success('Issue Inventory deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateIssueInventory = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue-inventory/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ISSUE_INVENTORY, payload: res.data.data });
         setTimeout(() => {
            toast.success('Issue Inventory updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const getLastIssueDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      // const res = await axios.get(`/issue/last`, { params });
      const res = await axios.get(`/issue-inventory/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_ISSUE_DAYBOOK, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      console.error('getLastIssueDaybook err', err);
   }
};

export const emptyIssueInventory = () => async (dispatch) => {
   dispatch({ type: EMPTY_ONE_ISSUE_INVENTORY, payload: null });
};

export const getPrevAndNext = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchase-invoice/prev-next`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_ISSUE_INVENTORY_PREV_AND_NEXT, payload: res.data.data });
      }
      return res.data.data;
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const addIssueReason = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue-inventory/update/addReturn`, formData);
      if (res.data.code === 1) {
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const uploadIssueDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/issue-inventory/addImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ISSUE_DOC, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const deleteIssueDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/issue-inventory/deleteImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: DELETE_ISSUE_DOC, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
